export default __webpack_public_path__ + "cfd140b1d9d0b720a5ed3dc734da5dbd.svg";